import * as THREE from "three";
import { FirstPersonControls } from "three/addons/controls/FirstPersonControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
//import GUI from "lil-gui";

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

// Debug
//const gui = new GUI();

const clock = new THREE.Clock();

//Textures

const textureLoader = new THREE.TextureLoader();
const floorColorTexture = textureLoader.load("textures/floor/Wood_Color.jpg");
const floorAmbientOcclusionTexture = textureLoader.load(
  "textures/floor/Wood_ambientOcclusion.jpg"
);
const floorNormalTexture = textureLoader.load("textures/floor/Wood_Normal.png");
const floorRoughnessTexture = textureLoader.load(
  "textures/floor/Wood_Roughness.jpg"
);

const wallColorTexture = textureLoader.load(
  "textures/walls/WhiteStuccoWall_Color.png"
);
const wallAmbientOcclusionTexture = textureLoader.load(
  "textures/walls/WhiteStuccoWall_AO.png"
);
const wallNormalTexture = textureLoader.load(
  "textures/walls/WhiteStuccoWall_Normal.png"
);
const wallRoughnessTexture = textureLoader.load(
  "textures/walls/WhiteStuccoWall_Roughness.png"
);
const wallHeightTexture = textureLoader.load(
  "textures/walls/WhiteStuccoWall_Height.png"
);

let floorTextures = [
  floorColorTexture,
  floorAmbientOcclusionTexture,
  floorNormalTexture,
  floorRoughnessTexture,
];
for (let i = 0; i < floorTextures.length; i++) {
  floorTextures[i].repeat.set(8, 8);
  floorTextures[i].wrapS = THREE.RepeatWrapping;
  floorTextures[i].wrapT = THREE.RepeatWrapping;
}

let wallTextures = [
  wallColorTexture,
  wallAmbientOcclusionTexture,
  wallNormalTexture,
  wallRoughnessTexture,
  wallHeightTexture,
];

for (let j = 0; j < wallTextures; j++) {
  wallTextures[j].repeat.set(4, 4);
  wallTextures[j].wrapS = THREE.RepeatWrapping;
  wallTextures[j].wrapT = THREE.RepeatWrapping;
}

//set colourspace to three.srgbcolorspace
floorColorTexture.colorSpace = THREE.SRGBColorSpace;
wallColorTexture.colorSpace = THREE.SRGBColorSpace;

//video - watched video & used code on how to create video texture
//https://www.youtube.com/watch?v=d1sr2oWnxus&ab_channel=flanniganable

let video = document.getElementById("video");
let videoTexture = new THREE.VideoTexture(video);

videoTexture.minFilter = THREE.LinearFilter;
videoTexture.magFilter = THREE.LinearFilter;

const movieMaterial = new THREE.MeshBasicMaterial({
  map: videoTexture, // set material map to video texture
  side: THREE.FrontSide,
  toneMapped: false,
});

/**
 * Models
 */

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("draco/");

const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

//plynth
gltfLoader.load("models/pedestal.glb", (gltf) => {
  const plynth = gltf.scene;
  plynth.position.set(8, 0, -9);
  plynth.scale.set(2, 2, 2);
  scene.add(gltf.scene);
});

//wall text
gltfLoader.load("models/gallery_text.glb", (gltf) => {
  const walltext = gltf.scene;
  walltext.position.set(-1, 1.6, -11);
  walltext.scale.set(0.5, 0.4, 0.5);
  scene.add(gltf.scene);
});

//play button
gltfLoader.load("models/play.glb", (gltf) => {
  const playb = gltf.scene;
  playb.rotateY(-Math.PI / 2);
  playb.position.set(12, 3, 9);
  playb.scale.set(0.6, 0.6, 0.6);
  scene.add(gltf.scene);
});

// melting models

let currentIndex = 0;
let rodin;
let carasModels = [];
let pots;

// Rodin model paths. Each model a different melt stage.
const rodinPaths = [
  "models/thinker.glb",
  "models/thinker_half.glb",
  "models/nearlygone.glb",
  "models/gone.glb",
];

const loadRodin = (index) => {
  gltfLoader.load(rodinPaths[index], (gltf) => {
    const model = gltf.scene;
    model.scale.set(1.44, 1.44, 1.44);
    model.position.set(0, 0, 0);
    model.castShadow = true;
    model.receiveShadow = true;
    scene.add(model);
    rodin = model;
  });
};

loadRodin(currentIndex);

//load pots, different melt stages
const potPaths = [
  "models/pot_melt_1.glb",
  "models/pot_melt_2.glb",
  "models/pot_melt_3.glb",
  "models/pot_melt_4.glb",
];

const loadPots = (index) => {
  gltfLoader.load(potPaths[index], (gltf) => {
    const pot = gltf.scene;
    pot.position.set(8, 2.4, -9);
    scene.add(pot);
    pots = pot;
  });
};

loadPots(currentIndex);

// cara models at different melt stages
const caraPaths = [
  "models/cara_full.glb",
  "models/cara_half.glb",
  "models/cara_threequart.glb",
  "models/cara_puddle.glb",
];

const loadCaras = (index) => {
  gltfLoader.load(caraPaths[index], (gltf) => {
    const caras1 = gltf.scene.clone();
    const caras2 = gltf.scene.clone();
    const caras3 = gltf.scene.clone();
    caras1.position.set(-9, 0, -6);
    caras2.position.set(-9, 0, 0);
    caras3.position.set(-9, 0, 6);
    caras1.rotateY(Math.PI / 2);
    caras2.rotateY(Math.PI / 2);
    caras3.rotateY(Math.PI / 2);
    scene.add(caras1);
    scene.add(caras2);
    scene.add(caras3);
    caras1.scale.set(4.5, 4.5, 4.5);
    caras2.scale.set(4.5, 4.5, 4.5);
    caras3.scale.set(4.5, 4.5, 4.5);
    carasModels.push(caras1, caras2, caras3);
  });
};

loadCaras(currentIndex);

//create screen for video

let movieScreenGeo = new THREE.PlaneGeometry(12, 7);
let movieScreen = new THREE.Mesh(movieScreenGeo, movieMaterial);

movieScreen.rotateY(-Math.PI / 2);
movieScreen.position.set(12, 5, 0);

scene.add(movieScreen);

// load all models

const loadNextModels = () => {
  currentIndex = (currentIndex + 1) % rodinPaths.length;

  // remove current models then add next one
  scene.remove(rodin);
  loadRodin(currentIndex);

  scene.remove(pots);
  loadPots(currentIndex);

  carasModels.forEach((obj) => scene.remove(obj));
  carasModels = [];
  loadCaras(currentIndex);
};

canvas.addEventListener("click", loadNextModels);

// Base camera
const camera = new THREE.PerspectiveCamera(
  100,
  window.innerWidth / window.innerHeight,
  0.1,
  100
);
camera.position.set(0, 2.7, 5);

//scene.add(camera);
// gui.add(camera.position, "x", 0, 25, 0.01);
// gui.add(camera.position, "y", -20, 10, 0.01);
// gui.add(camera.position, "z", 0, 25, 0.01);

// Renderer
const renderer = new THREE.WebGLRenderer({ canvas });
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

//Group

const gallery = new THREE.Group();
scene.add(gallery);

const listener = new THREE.AudioListener();
camera.add(listener);

//global audio source - used documentation on how to do this: https://threejs.org/docs/#api/en/audio/Audio
const context = new AudioContext();
const sound = new THREE.Audio(listener);
let audioStarted = false; // track whether audio has been started

// load a sound and set it as the audio buffer object.
const audioLoader = new THREE.AudioLoader();
audioLoader.load("Kristen_Nogues_Enez_ Rouz_Edit.mp3", function (buffer) {
  sound.setBuffer(buffer);
  sound.setLoop(true);
  sound.setVolume(0.4);
  sound.pause();
});

// Event listener for keydown event
document.addEventListener("keydown", (event) => {
  if (event.key === "p" && !audioStarted) {
    context.resume();
    sound.play();
    audioStarted = true;
  }
});

/**
 * Floor
 */
const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(25, 25),
  new THREE.MeshStandardMaterial({
    map: floorColorTexture,
    aoMap: floorAmbientOcclusionTexture,
    normalMap: floorNormalTexture,
    roughnessMap: floorRoughnessTexture,
    metalness: 0.85,
    roughness: 0.5,
  })
);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI * 0.5;
floor.position.y = 0;
scene.add(floor);

/**
 * Walls
 */

const material = new THREE.MeshStandardMaterial({
  map: wallColorTexture,
  aoMap: wallAmbientOcclusionTexture,
  normalMap: wallNormalTexture,
  roughnessMap: wallRoughnessTexture,
});

const length = 25;
const height = 10;

const wall1Geometry = new THREE.PlaneGeometry(length, height);
const wall2Geometry = new THREE.PlaneGeometry(length, height);
const wall3Geometry = new THREE.PlaneGeometry(length, height);
const wall4Geometry = new THREE.PlaneGeometry(length, height);

// Rotate walls to form a box
wall1Geometry.rotateY(Math.PI / 2);
wall1Geometry.translate(-length / 2, height / 2, 0);

wall2Geometry.rotateY(-Math.PI / 2);
wall2Geometry.translate(length / 2, height / 2, 0);

//wall3Geometry.rotateY(Math.PI);
wall3Geometry.translate(0, height / 2, -length / 2);

wall4Geometry.rotateY(Math.PI);
wall4Geometry.translate(0, height / 2, length / 2);

// Create mesh for each wall
const wall1 = new THREE.Mesh(wall1Geometry, material);
const wall2 = new THREE.Mesh(wall2Geometry, material);
const wall3 = new THREE.Mesh(wall3Geometry, material);
const wall4 = new THREE.Mesh(wall4Geometry, material);

// Add walls to the scene
gallery.add(wall1);
gallery.add(wall2);
gallery.add(wall3);
gallery.add(wall4);

/**
 * Lights
 */
//purplish toplight
const ambientLight = new THREE.AmbientLight(0x5f41a7, 2);
ambientLight.position.set(-3, 5, 0);
scene.add(ambientLight);

//wall lights
const directionalLight = new THREE.DirectionalLight(0xffffff, 0.4);
directionalLight.position.set(-3.27, -0.08, -10);
scene.add(directionalLight);

//play lights
//wall lights
const playLight = new THREE.SpotLight(0xffffff, 10);
playLight.position.set(11.03, 4.14, 9.24);
playLight.angle = Math.PI * 0.99;
playLight.distance = 5;
scene.add(playLight);

//spotlight on rodin
const spotLight = new THREE.SpotLight(0xffffff, 20);
spotLight.position.set(-2.05, 2.67, 2.13);
spotLight.angle = Math.PI * 0.32;
spotLight.castShadow = true;
spotLight.penumbra = 1;
spotLight.distance = 10;
spotLight.map = new THREE.TextureLoader().load("textures/earth.png");
spotLight.shadow.mapSize.width = 100;
spotLight.shadow.mapSize.height = 100;
spotLight.shadow.camera.near = 1;
spotLight.shadow.camera.far = 10;
spotLight.shadow.focus = 1;
scene.add(spotLight);

//spotlights on caratides
const spotLight2 = new THREE.SpotLight(0xbb0000, 50);
spotLight2.position.set(-8.44, 1.93, -6.22);
spotLight2.angle = Math.PI * 1.138;
spotLight2.castShadow = true;
spotLight2.distance = 2.87;
spotLight2.penumbra = 0;
scene.add(spotLight2);

//spotlight on 2nd cara
const spotLight3 = new THREE.SpotLight(0xbb0000, 50);
spotLight3.position.set(-8.68, 1.93, -0.08);
spotLight3.angle = Math.PI * 1.138;
spotLight3.castShadow = true;
spotLight3.distance = 2.87;
spotLight3.penumbra = 0;
scene.add(spotLight3);

//spotlight on 3rd cara
const spotLight4 = new THREE.SpotLight(0xbb0000, 50);
spotLight4.position.set(-8.68, 1.93, 5.82);
spotLight4.angle = Math.PI * 1.138;
spotLight4.castShadow = true;
spotLight4.distance = 2.87;
spotLight4.penumbra = 0;
scene.add(spotLight4);

//spotlight on wall text
const spotLight5 = new THREE.SpotLight(0xffffff, 20);
spotLight5.position.set(0.66, -0.28, -11.02);
spotLight5.angle = Math.PI * 1.066;
spotLight5.castShadow = true;
spotLight5.distance = 10;
spotLight5.penumbra = 0;
scene.add(spotLight5);

//tweak the x,y, colour propety of the objects' light position
// gui.add(playLight.position, "y", -10, 20, 0.01);
// gui.add(playLight.position, "x", 10, 20, 0.01);
// gui.add(playLight.position, "z", -20, 10, 0.01);
// gui.add(playLight, "distance", 10, 20, 0.01).name("directionalLight Distance");
// // gui.addColor(spotLight5, "color");
// gui.add(playLight, "angle", 0, Math.PI * 2, 0.01).name("Spotlight Angle");

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Controls
const controls = new FirstPersonControls(camera, renderer.domElement);
controls.movementSpeed = 2;
controls.lookSpeed = 0.02;
//controls.activeLook = false;

// Animate scene
function animate() {
  requestAnimationFrame(animate);
  render();
}

animate();

//render scene and update time
function render() {
  controls.update(clock.getDelta());
  renderer.render(scene, camera);

  //used this code for spotlights from https://github.com/mrdoob/three.js/blob/master/examples/webgl_lights_spotlight.html
  const time = performance.now() / 3000;
  spotLight.position.x = Math.cos(time) * 2.5;
  spotLight.position.z = Math.sin(time) * 2.5;

  //update directionalLight position
  const startY = -0.65;
  const endY = -10;
  const t = Math.sin(time) + 1;
  directionalLight.position.y = THREE.MathUtils.lerp(startY, endY, t);

  //update video texture with new image of video
  videoTexture.needsUpdate = true;
}
